import Cookies from 'js-cookie'

const PageLoginReffer = 'e10adc3949ba59abbe56e057f20f883e';
export function setPageLoginReffer(reffer) {
    return Cookies.set(PageLoginReffer, reffer)
}

export function getPageLoginReffer() {
    return Cookies.get(PageLoginReffer)
}
